/**
 * @createdBy:HuangJian
 * @date:2018/12/1
 * @description：
 *
 * filters下存放所有的公共过滤器
 * filters.lovName = function……
 * lovName 表示过滤器名称；其后面的function 为相应处理方法
 */
var filters = {};

/**
 *@methods:transformArr
 *@description:把后台传回来的值列表数组转化为显示值
 */
filters.transformArr = function(val, type){
    if (val == 'undefined') return '';
    if (!val) return '';
    if (typeof val !== 'string') return val;
    var data = val.split(',');
    var str = '';
    for (var i in data) {
        str += linkLov.getLovShowName(type, data[i]) + ' ';
    }
    return str;
};

// 转换为百分比数字，并保留2位小数
filters.formatPercent = function(d) {
    // 转换为两位小数
    if (linkTools.isEmpty(d)) {
        return '';
    }
    if (isNaN(d) == true) {
        return '';
    }
    var percentNum = parseFloat(d).toFixed(4)*100;
    return percentNum;
};

// 转换为人民币显示
filters.cny = function(d){
    // 转换为人民币显示
    if (linkTools.isEmpty(d)) {
        return '￥0';
    }
    if (isNaN(d) == true) {
        return '无效的金额';
    }
    var dd = parseFloat(d);
    return '￥' + String(dd.toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
};

/**
 *@methods:MoneyFormat
 *@description:金额分隔符过滤器
 **/
filters.money = function (val) {
    if (val || val == 0) {
        val = val.toString().replace(/\$|\, /g, '');
        if (isNaN(val)) {
            val = '0';
        }
        const sign = val == (val = Math.abs(val));
        val = Math.floor(val * 100 + 0.50000000001);
        let cents = val % 100;
        val = Math.floor(val / 100).toString();
        if (cents < 10) {
            cents = '0' + cents;
        }
        for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
            val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
        }
        return (sign ? '' : '-') + val + '.' + cents;
    }
};
// 格式化手机号码
filters.xtel = function (d) {
    if (linkTools.isEmpty(d)) {
        return '';
    }
    d = String(d);
    d=d.trim();
    if(d.length>=11){
        var d1=d.substr(d.length-4, 4);
        var d2=d.substr(d.length-8, 4);
        var d3=d.substr(d.length-11, 3);
        return d3+' '+d2+' '+d1;
    }else{
        return d;
    }
};
/**
 * @createdBy:HuangJian
 * @date:2018/11/20
 * @params：
 * @description：转换为yyyy-MM-dd格式
 */

filters.xdate = function (d) {
    let result = '';
    try {
        result = new Date(d).format('yyyy-MM-dd');
    } catch (e) {
        result = d;
    }
    return result;
};
/**
 * @createdBy:WangYue
 * @date:2019/4/28
 * @params：36/10
 * @description：将数据十进制数字转化成三十六进制
 */
filters.LinkIdToString = function(val){
    let num = (val-0).toString(36);
    if(isNaN(val-0)){
        return val;
    }else {
        return num.toUpperCase();
    }
};
/**
 * @createdBy:WangYue
 * @date:2019/4/28
 * @params：36/10
 * @description：将三十六进制数字转换成十进制
 */
filters.LinkStringToId = function(val){
    let num = parseInt(val,36);
    console.log(num);
    if(isNaN(num)){
        return val;
    }else {
        return num;
    }
};
/**
 * 根据值列表类型、独立源代码转换为显示值过滤器
 * @author:yrf
 * @demo
 <!-- 值列表测试 -->
 <div>{{lovValue1 | lovName(lovType)}}</div>
 */

filters.lovName =function (value, type) {
    if(typeof value !== 'string') return value;
    return linkLov.getLovShowName(type, value);
};

/**
 * 作者：王越
 * 时间：2018-04-30
 * 内容：日期过滤器，过滤掉日期后的时间字段。
 * */

filters.dateFilter = function(d){
    if(d != undefined){
        var arr = d.split('');
        if(arr.indexOf(' ') != -1){
            return arr.slice(0, arr.indexOf(' ')).join('');
        }else{
            return d;
        }
    }else{
        return '暂无日期';
    }
};

filters.xday = function (d) {
    var result;
    var dateTimeStamp = Date.parse(d.replace(/-/gi, '/'));
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;
    var now = new Date().getTime();
    var diffValue = now - dateTimeStamp;
    if (diffValue < 0) {
        return;
    }
    var monthC = diffValue / month;
    var weekC = diffValue / (7 * day);
    var dayC = diffValue / day;
    var hourC = diffValue / hour;
    var minC = diffValue / minute;
    if (monthC >= 1) {
        result = String(parseInt(monthC)) + '月前';
    } else if (weekC >= 1) {
        result = String(parseInt(weekC)) + '周前';
    } else if (dayC >= 1) {
        result = String(parseInt(dayC)) + '天前';
    } else if (hourC >= 1) {
        result = String(parseInt(hourC)) + '小时前';
    } else if (minC >= 1) {
        result = String(parseInt(minC)) + '分钟前';
    } else
        result = '刚刚';
    return result;
};

/**
 * @method：formatDate
 * @createdBy:HuangJian
 * @date:2018/12/1
 * @params：
 * @description：按指定的格式显示日期
 */
filters.formatDate = function (val, format) {
    var result = val;
    if(val && format){
        try{
            val = val.replace(/-/g, '/').replace(/.[0-9]+$/, '');
            result = new Date(val).format(format);
        }catch (e){}
    }
    return result;
};
/**
 * @method：formatStrDate
 * @createdBy:常九福
 * @date:2019/04/11
 * @params：
 * @description：按指定的格式显示日期显示为****年**月**日**点
 */
filters.formatStrDate = function (val, format) {
    var result = filters.formatDate(val, format).split('-');
    var str = result[0] + '年' + result[1] + '月' + result[2] + '日' + result[3] + '点';
    return str;
};

filters.integer = function (val) {
    var result = val;
    if (typeof result === 'string'){
        return Math.round(Number(result));
    }else if(typeof result === 'number'){
        return Math.round(result);
    }else{
        return 0;
    }
};

/**
 * @createdBy:HuangJian
 * @date:2018/12/1
 * @description：过滤器安装函数（勿动）
 */
const install = (vue) => {
    for(var key in filters){
        vue.filter(key, filters[key]);
    }
};

export default {install};
